// extracted by mini-css-extract-plugin
export default {"guide":"fade10794c10"};